import PropTypes from 'prop-types';
import Button from './Button';
const Banner = ({ label, onClick, variant = 'warning', disabled = false, icon = null, className }) => {
	const variantClasses = {
		neutral: 'bg-gray-50 text-gray-900 border-gray-200',
		info: 'bg-cyan-50 text-cyan-800 border-cyan-200',
		success: 'bg-green-50 text-green-900 border-green-200',
		warning: 'bg-amber-50 text-amber-800 border-amber-200',
		error: 'bg-red-50 text-red-900 border-red-200',
		alpha: 'bg-gray-50/20 text-gray-900 border-none',
	};

	const defaultIcon = variant === 'alpha' ? 'ri-information-line' : 'ri-information-fill';
	const iconClass = icon || defaultIcon;

	return (
		<div className={`flex items-center gap-2 p-2.5 rounded-md border ${variantClasses[variant]} ${className}`}>
			<i className={`${iconClass} text-2xl leading-none self-start`} />
			<p>{label}</p>
			{onClick && <Button onClick={onClick} disabled={disabled}></Button>}
		</div>
	);
};

Banner.propTypes = {
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	onClick: PropTypes.func,
	variant: PropTypes.oneOf(['info', 'success', 'warning', 'error', 'neutral', 'alpha']),
	disabled: PropTypes.bool,
	icon: PropTypes.string,
	className: PropTypes.string,
};

export default Banner;
